// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules_dev/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#appleid-signin>div{max-width:none!important}#appleid-signin>div>div>svg{height:45px;width:100%}#appleid-signin>div>div>svg>rect{ry:5%}", ""]);
// Exports
module.exports = exports;
